import React from "react";
import {
  Box,
  Pagination,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from "@mui/material";

const ExpedicaoPagination = ({ 
  currentPage, 
  totalPages, 
  totalItems,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange 
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 2,
        backgroundColor: "white",
        borderBottom: "1px solid rgba(0,0,0,0.1)"
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Typography variant="body2" color="#666">
          Total: {totalItems} itens
        </Typography>
        
        <FormControl size="small" sx={{ minWidth: 80 }}>
          <InputLabel>Por página</InputLabel>
          <Select
            value={itemsPerPage}
            label="Por página"
            onChange={(e) => onItemsPerPageChange(e.target.value)}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Typography variant="body2" color="#666">
          Página {currentPage} de {totalPages}
        </Typography>
        
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(event, value) => onPageChange(value)}
          color="primary"
          size="small"
          showFirstButton
          showLastButton
          sx={{
            "& .MuiPaginationItem-root": {
              fontSize: "0.875rem"
            },
            "& .Mui-selected": {
              backgroundColor: "#FF7322 !important",
              color: "white"
            }
          }}
        />
      </Box>
    </Box>
  );
};

export default ExpedicaoPagination;